import React, { useState, useEffect } from 'react'
import Layout from '../../../../components/vision/Layout'
import ProtectedRoute from '../../../../components/vision/ProtectedRoute'

export default function ConfiguracaoKPIsPage() {
  const [clientes, setClientes] = useState<any[]>([])
  const [selectedCliente, setSelectedCliente] = useState<any>(null)
  const [indicadoresDisponiveis, setIndicadoresDisponiveis] = useState<any[]>([])
  const [indicadoresAtivos, setIndicadoresAtivos] = useState<any[]>([])
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    fetchClientes()
    fetchIndicadoresDisponiveis()
  }, [])

  const fetchClientes = async () => {
    try {
      const res = await fetch('/api/gestao/clientes')
      if (res.ok) {
        const response = await res.json()
        // API retorna { data, error } ou array direto
        const clientesData = response.data || response
        setClientes(Array.isArray(clientesData) ? clientesData : [])
      }
    } catch (error) {
      console.error('Erro ao buscar clientes:', error)
      setClientes([])
    }
  }

  const fetchIndicadoresDisponiveis = async () => {
    try {
      const res = await fetch('/api/gestao/kpis/indicador-tipos')
      if (res.ok) {
        const data = await res.json()
        setIndicadoresDisponiveis(Array.isArray(data) ? data : [])
      }
    } catch (error) {
      console.error('Erro ao buscar indicadores:', error)
      setIndicadoresDisponiveis([])
    }
  }

  const fetchIndicadoresCliente = async (clienteId: string) => {
    try {
      const res = await fetch(`/api/gestao/kpis/cliente-indicadores?cliente_id=${clienteId}`)
      if (res.ok) {
        const data = await res.json()
        setIndicadoresAtivos(Array.isArray(data) ? data : [])
      }
    } catch (error) {
      console.error('Erro ao buscar indicadores do cliente:', error)
      setIndicadoresAtivos([])
    }
  }

  const handleSelectCliente = (cliente: any) => {
    setSelectedCliente(cliente)
    fetchIndicadoresCliente(cliente.id)
  }

  const handleToggleIndicador = async (indicadorId: string, ativo: boolean) => {
    const indicadoresAtualizados = ativo
      ? [...indicadoresAtivos.map((i: any) => i.indicador_tipo_id), indicadorId]
      : indicadoresAtivos.filter((i: any) => i.indicador_tipo_id !== indicadorId).map((i: any) => i.indicador_tipo_id)

    await fetch('/api/gestao/kpis/cliente-indicadores', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cliente_id: selectedCliente.id,
        indicadores: indicadoresAtualizados.map((id: string, index: number) => ({
          indicador_tipo_id: id,
          ativo: true,
          ordem_exibicao: index + 1
        }))
      })
    })

    fetchIndicadoresCliente(selectedCliente.id)
  }

  const isIndicadorAtivo = (indicadorId: string) => {
    return indicadoresAtivos.some((i: any) => i.indicador_tipo_id === indicadorId)
  }

  const getIndicadoresAtivosCount = () => {
    return indicadoresAtivos.length
  }

  const filteredClientes = clientes.filter((cliente: any) => {
    const searchLower = searchTerm.toLowerCase()
    return (
      cliente.nome_empresa?.toLowerCase().includes(searchLower) ||
      cliente.razao_social?.toLowerCase().includes(searchLower) ||
      cliente.email?.toLowerCase().includes(searchLower)
    )
  })

  return (
    <ProtectedRoute>
      <Layout>
        <div className="p-8 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-800 mb-2">Configuração de KPIs</h1>
            <p className="text-gray-600">Vincule indicadores de desempenho aos seus clientes</p>
          </div>

          <div className="grid grid-cols-12 gap-6">
            {/* Lista de Clientes */}
            <div className="col-span-4">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4">
                  <h2 className="text-xl font-bold text-white flex items-center gap-2">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    Clientes
                  </h2>
                  <p className="text-orange-100 text-sm mt-1">{clientes.length} clientes cadastrados</p>
                </div>
                <div className="p-4">
                  {/* Campo de Busca */}
                  <div className="mb-4">
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Buscar cliente..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full pl-10 pr-10 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                      />
                      <svg className="absolute left-3 top-3.5 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                      {searchTerm && (
                        <button
                          onClick={() => setSearchTerm('')}
                          className="absolute right-3 top-3.5 text-gray-400 hover:text-gray-600 transition-colors"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="space-y-2 max-h-[520px] overflow-y-auto custom-scrollbar">
                    {Array.isArray(filteredClientes) && filteredClientes.length > 0 ? (
                      filteredClientes.map((cliente: any) => (
                        <button
                          key={cliente.id}
                          onClick={() => handleSelectCliente(cliente)}
                          className={`w-full text-left px-4 py-4 rounded-xl transition-all duration-200 group ${
                            selectedCliente?.id === cliente.id 
                              ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg scale-105' 
                              : 'bg-gray-50 hover:bg-gray-100 hover:shadow-md text-gray-700'
                          }`}
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="font-semibold text-sm">
                                {cliente.nome_empresa || cliente.razao_social}
                              </div>
                              {cliente.email && (
                                <div className={`text-xs mt-1 ${
                                  selectedCliente?.id === cliente.id ? 'text-orange-100' : 'text-gray-500'
                                }`}>
                                  {cliente.email}
                                </div>
                              )}
                            </div>
                            {selectedCliente?.id === cliente.id && (
                              <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                              </svg>
                            )}
                          </div>
                        </button>
                      ))
                    ) : (
                      <div className="text-center py-12 text-gray-400">
                        <svg className="w-16 h-16 mx-auto mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={searchTerm ? "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" : "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"} />
                        </svg>
                        <p className="font-medium">{searchTerm ? 'Nenhum cliente encontrado' : 'Nenhum cliente cadastrado'}</p>
                        {searchTerm && (
                          <p className="text-sm mt-2">Tente buscar por outro termo</p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Painel de Indicadores */}
            <div className="col-span-8">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                {selectedCliente ? (
                  <>
                    <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-4">
                      <div className="flex items-center justify-between">
                        <div>
                          <h2 className="text-xl font-bold text-white flex items-center gap-2">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                            Indicadores de Desempenho
                          </h2>
                          <p className="text-blue-100 text-sm mt-1">{selectedCliente.nome_empresa || selectedCliente.razao_social}</p>
                        </div>
                        <div className="bg-white bg-opacity-20 backdrop-blur-sm px-4 py-2 rounded-lg">
                          <div className="text-white text-center">
                            <div className="text-2xl font-bold">{getIndicadoresAtivosCount()}</div>
                            <div className="text-xs text-blue-100">Ativos</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-6">
                      <div className="grid grid-cols-1 gap-4 max-h-[600px] overflow-y-auto custom-scrollbar">
                        {Array.isArray(indicadoresDisponiveis) && indicadoresDisponiveis.length > 0 ? (
                          indicadoresDisponiveis.map((indicador: any) => {
                            const isAtivo = isIndicadorAtivo(indicador.id)
                            return (
                              <div 
                                key={indicador.id} 
                                className={`group relative overflow-hidden rounded-xl border-2 transition-all duration-200 ${
                                  isAtivo 
                                    ? 'border-green-400 bg-green-50 shadow-md' 
                                    : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
                                }`}
                              >
                                <div className="flex items-center justify-between p-5">
                                  <div className="flex-1">
                                    <div className="flex items-center gap-3 mb-2">
                                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                                        isAtivo ? 'bg-green-500' : 'bg-gray-200'
                                      }`}>
                                        <svg className={`w-6 h-6 ${isAtivo ? 'text-white' : 'text-gray-500'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                        </svg>
                                      </div>
                                      <div className="flex-1">
                                        <h3 className="font-bold text-gray-800 text-lg">{indicador.nome}</h3>
                                        {isAtivo && (
                                          <span className="inline-flex items-center gap-1 px-2 py-1 bg-green-500 text-white text-xs font-medium rounded-full mt-1">
                                            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                            Ativo
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <p className="text-sm text-gray-600 leading-relaxed">{indicador.descricao}</p>
                                  </div>
                                  <label className="relative inline-flex items-center cursor-pointer ml-4">
                                    <input
                                      type="checkbox"
                                      checked={isAtivo}
                                      onChange={(e) => handleToggleIndicador(indicador.id, e.target.checked)}
                                      className="sr-only peer"
                                    />
                                    <div className="w-14 h-7 bg-gray-300 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-orange-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-green-500"></div>
                                  </label>
                                </div>
                              </div>
                            )
                          })
                        ) : (
                          <div className="text-center py-16 text-gray-400">
                            <svg className="w-20 h-20 mx-auto mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                            <p className="font-medium text-lg">Nenhum indicador disponível</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="flex items-center justify-center h-full min-h-[600px]">
                    <div className="text-center">
                      <div className="w-24 h-24 bg-gradient-to-br from-orange-100 to-orange-200 rounded-full flex items-center justify-center mx-auto mb-6">
                        <svg className="w-12 h-12 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122" />
                        </svg>
                      </div>
                      <h3 className="text-2xl font-bold text-gray-700 mb-2">Selecione um Cliente</h3>
                      <p className="text-gray-500">Escolha um cliente na lista ao lado para configurar seus indicadores</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #cbd5e0;
            border-radius: 10px;
          }
          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background: #a0aec0;
          }
        `}</style>
      </Layout>
    </ProtectedRoute>
  )
}
